"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Success = void 0;
var React = require("react");
var Icon_styled_1 = require("../Icon.styled");
var common_styles_1 = require("@next-components/common-styles");
/**
 * Source: https://github.com/microsoft/fluentui-system-icons/blob/master/icons.md
 * name: "Person (Filled)"
 */
exports.Success = function (props) { return (React.createElement(Icon_styled_1.StyledSvg, { width: "22", height: "22", viewBox: "0 0 22 22", fill: "none" },
    React.createElement("circle", { cx: "11", cy: "11", r: "11", fill: common_styles_1.positive }),
    React.createElement("path", { d: "M7.33301 10.9555L10.2945 13.9346L15.033 9.16797", stroke: common_styles_1.white, strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }))); };
//# sourceMappingURL=success.js.map